import { render, staticRenderFns } from "./china-map.vue?vue&type=template&id=64a23e06&scoped=true&"
import script from "./china-map.vue?vue&type=script&lang=js&"
export * from "./china-map.vue?vue&type=script&lang=js&"
import style0 from "./china-map.vue?vue&type=style&index=0&id=64a23e06&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a23e06",
  null
  
)

export default component.exports